module.exports = __webpack_public_path__ + "assets/openresty.af9772d5.svg";